// Guide + Manual on every module (ModuleHelp.jsx, Max 01/11).
const en = {
  manual: 'Manual',
  manualHint: 'Read the manual here — right-click to open it in a new tab',
  newTab: 'Open in new tab',
  close: 'Close',
  tourManualT: 'The manual',
  tourManualB: 'Everything this screen does, step by step, is in the manual. Click to read it here beside your work, or right-click to open it in a new tab. The Guide button next to it replays this tour any time.',
  tourReplayT: 'Replay this guide',
  tourReplayB: 'Click Guide any time to walk through this screen again.',
};

const ko = {
  manual: '매뉴얼',
  manualHint: '여기서 매뉴얼 보기 — 오른쪽 클릭하면 새 탭에서 열림',
  newTab: '새 탭에서 열기',
  close: '닫기',
  tourManualT: '매뉴얼',
  tourManualB: '이 화면의 모든 기능은 매뉴얼에 단계별로 있습니다. 클릭하면 작업 화면 옆에서 바로 보고, 오른쪽 클릭하면 새 탭에서 열립니다. 옆의 안내 버튼으로 이 투어를 언제든 다시 볼 수 있습니다.',
  tourReplayT: '안내 다시 보기',
  tourReplayB: '안내 버튼을 누르면 언제든 이 화면 안내를 다시 볼 수 있습니다.',
};

const vi = {
  manual: 'Sổ tay',
  manualHint: 'Đọc sổ tay ngay tại đây — chuột phải để mở ở tab mới',
  newTab: 'Mở ở tab mới',
  close: 'Đóng',
  tourManualT: 'Sổ tay hướng dẫn',
  tourManualB: 'Mọi chức năng của màn hình này được hướng dẫn từng bước trong sổ tay. Bấm để đọc ngay bên cạnh màn hình đang làm, hoặc chuột phải để mở ở tab mới. Nút Hướng dẫn bên cạnh xem lại tour này bất cứ lúc nào.',
  tourReplayT: 'Xem lại hướng dẫn',
  tourReplayB: 'Bấm Hướng dẫn bất cứ lúc nào để được dẫn qua màn hình này lần nữa.',
};

const zh = {
  manual: '使用手册',
  manualHint: '在此阅读手册 — 右键可在新标签页打开',
  newTab: '在新标签页打开',
  close: '关闭',
  tourManualT: '使用手册',
  tourManualB: '本页面的全部功能都在手册中逐步说明。点击即可在工作页面旁阅读，右键可在新标签页打开。旁边的导览按钮可随时重新播放本导览。',
  tourReplayT: '重新播放导览',
  tourReplayB: '随时点击导览按钮，再次了解本页面。',
};

const dictionary = { ns: 'xHelp', en, ko, vi, zh };

export default dictionary;
